import React from 'react';

export const NPSSurveyContext = React.createContext<{
  tryToShowNPSSurvey: () => void;
}>({
  tryToShowNPSSurvey: () => undefined,
});
